import {useAuth0} from "@auth0/auth0-react";
import {Button} from "react-bootstrap";

function LoginLogout() {
    const {isAuthenticated, isLoading} = useAuth0();

    function LoginButton() {
        const {loginWithRedirect} = useAuth0();

        return <Button onClick={() => loginWithRedirect()}>Log In</Button>
    }

    function LogoutButton() {
        const {logout} = useAuth0();

        return (
            <div>
                <Button onClick={() => logout({returnTo: window.location.origin})}>Log Out</Button>
            </div>
        )
    }

    if (isLoading) {
        return <></>
    }

    return (
        <div id={'login'}>
            {!isAuthenticated ?
                <LoginButton /> : <LogoutButton />}
        </div>
    )
}

export default LoginLogout;